var map = {
	"./symbol_0.png": 54991,
	"./symbol_1.png": 15974,
	"./symbol_2.png": 57213,
	"./symbol_3.png": 36084,
	"./symbol_4.png": 81995,
	"./symbol_5.png": 60866,
	"./symbol_6.png": 9049,
	"./symbol_7.png": 12144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66954;